<template>
  <svg
    width="82"
    height="76"
    viewBox="0 0 82 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 55.3163L38.4082 74.0204L79 55.3163L38.4082 39L1 55.3163Z"
      fill="var(--livi-primary)"
      stroke="white"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M1 43.3163L38.4082 62.0204L79 43.3163L38.4082 27L1 43.3163Z"
      fill="white"
      stroke="white"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M1 31.3163L38.4082 50.0204L79 31.3163L38.4082 15L1 31.3163Z"
      fill="var(--livi-primary)"
      stroke="white"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M1 19.3163L38.4082 38.0204L79 19.3163L38.4082 3L1 19.3163Z"
      fill="var(--livi-primary)"
      stroke="white"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>
